export default __webpack_public_path__ + "static/trade-0c3cf8d4305c287a41117c810da66442.png";